export default {
  description:
    'このページで有効化された言語のみ、消費者側で切り替え可能です。消費者側ページではデフォルト言語が優先表示されます',
  language: '言語',
  defaultLanguage: 'デフォルト言語',
  enabled: '有効/無効',
  traditionalChinese: '繁體中文',
  simplifiedChinese: '簡体中文',
  english: 'English',
  japanese: '日本語',
  save: '保存',
  saveSuccess: '保存しました',
};
